import React, { useMemo } from "react";
import { twMerge } from "tailwind-merge";

export interface BreadCrumbsProps {
  path: string;
  appendToPath: string;
}
const BreadCrumbs: React.FunctionComponent<BreadCrumbsProps> = ({
  path,
  appendToPath,
}) => {
  const pathArray = appendToPath?.length
    ? [appendToPath, ...path.split("/").filter((v) => v.length)]
    : [...path.split("/").filter((v) => v.length)];
  const pathLength = useMemo(() => pathArray?.length ?? 0, [pathArray]);
  return (
    <div className="hidden md:block">
      {pathArray.map((pathSegment, index) => {
        const isLast = index === pathLength - 1;
        const lastClassName = isLast ? "text-grey-80 cursor-pointer" : "";
        return (
          <span key={pathSegment} className="first:pl-0">
            <span
              key={pathSegment}
              className={twMerge("capitalize", lastClassName)}
            >
              {pathSegment?.replace(/-/g, " ")}
            </span>
            {index < pathLength - 1 && <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>}
          </span>
        );
      })}
    </div>
  );
};
export default BreadCrumbs;
